(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zenpaaw-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const dialog = document.getElementById('zp-welcome');
  const welcomeKey = 'zenpaaw-welcome-seen';
  let seen = true;
  try { seen = localStorage.getItem(welcomeKey) === 'seen'; } catch (e) {}
  if (dialog && !seen && !reduced.matches && !window.Shopify?.designMode && typeof dialog.showModal === 'function') {
    const close = () => { if (dialog.open) dialog.close(); };
    dialog.querySelectorAll('[data-zp-dismiss]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('cancel', close);
    try {
      localStorage.setItem(welcomeKey, 'seen');
      dialog.showModal();
    } catch (e) { close(); }
  }
  const enhance = (root = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (reduced.matches) return;
        entry.target.animate([{transform:'translateY(18px)',opacity:.65},{transform:'translateY(0)',opacity:1}],{duration:500,easing:'cubic-bezier(.2,.7,.2,1)'});
      });
    }, {threshold:.12});
    root.querySelectorAll('.zp-pet,.zp-play-card,.zp-faq-item,.zp-mission-box').forEach(el => {
      if (el.dataset.zpMotion) return;
      el.dataset.zpMotion = 'ready';
      if (el.getBoundingClientRect().top > window.innerHeight) observer.observe(el);
    });
    root.querySelectorAll('.zp-faq-item').forEach(el => {
      if (el.dataset.zpFaq) return;
      el.dataset.zpFaq = 'ready';
      el.addEventListener('toggle', () => {
        if (el.open && !reduced.matches) el.querySelector('.zp-faq-answer').animate([{opacity:0,transform:'translateY(-5px)'},{opacity:1,transform:'translateY(0)'}],{duration:220,easing:'ease-out'});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), {once:true});
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
